<template>
  <div class="container">
    <end-view v-if="completed" :points="points" :url="url" @restart="restart" />
    <quiz v-else-if="started" @complete="complete" @pointIncrease="addPoint" />
    <start-view v-else @start="start" />
  </div>
</template>

<script>
import EndView from "./components/EndView.vue";
import Quiz from "./components/Quiz.vue";
import StartView from "./components/StartView.vue";

export default {
  props: ["url"],
  name: "App",
  components: {
    Quiz,
    StartView,
    EndView,
  },
  data() {
    return {
      started: false,
      completed: false,
      points: 0,
    };
  },
  methods: {
    start() {
      this.started = true;
      this.pushToDataLayer("start-test");
    },
    complete() {
      this.completed = true;
      this.pushToDataLayer("finish-test");
    },
    restart() {
      this.started = false;
      this.completed = false;
      this.points = 0;
    },
    addPoint() {
      this.points++;
    },
    pushToDataLayer(eventName) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: eventName,
        });
      }
    },
  },
};
</script>

<style>
* {
  --quiz-backgroud-color: #fff;
  --quiz-border-color: #717171;
  --quiz-text-color: #717171;
  --quiz-header-color: #33a7d8;
  --quiz-link-color: #33a7d8;
  --quiz-button-color: #000;
  --quiz-button-text-color: #fff;
  --quiz-button-hover-color: #33a7d8;
  --quiz-button-hover-text-color: #fff;
  --quiz-option-color: #ccc;
  --quiz-option-text-color: #000;
  --quiz-option-hover-color: #000;
  --quiz-option-hover-text-color: #fff;
  --quiz-selected-color: #33a7d8;
  --quiz-selected-text-color: #fff;
  --quiz-correct-color: #228b22;
  --quiz-incorrect-color: #dc143c;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Raleway", "Helvetica Neue", Helvetica, sans-serif;
}

.container {
  background-color: var(--quiz-backgroud-color);
  padding-bottom: 10px;
  text-align: left;
  border: 1px solid var(--quiz-border-color);
  border-radius: 0;
  overflow: hidden;
}

a {
  color: var(--quiz-link-color);
  text-decoration: none;
}

h3 {
  font-weight: 500;
  font-size: 23px;
  text-transform: uppercase;
  color: var(--quiz-header-color);
}

p {
  line-height: 1.68;
  font-size: 16.5px;
}
</style>
